import Base64 from 'crypto-js/enc-base64'
import CryptoJS from 'crypto-js'
import sha256 from 'crypto-js/sha256'
export default {
  data () {
    return {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      repeatPassword: '',
      promoCode: '',
      terms: false,
      privacy: false,
      commercial: false,
      recaptchaKey: this.$recaptchaKey,
      recaptchaError: false,
      visiblePassword: false,
      window: window,
      complete: false,
      userInfo: null,
      defaultMethods: null,
      methodsHidden: false,
      advancedUser: false
    }
  },
  beforeMount () {
    this.complete = window.location.pathname === '/complete-register.html' || window.location.pathname === '/match.html'
    document.title = this.$tf('SignUp')
    if (!this.complete) {
      this.email = decodeURIComponent(this.urlParams.get('email') || this.urlParams.get('username') || '')
      this.accessMethods = this.lMethods()
      this.completeLoginMethods()
      let passMethod = this.accessMethods.find(method => method.type === 'password')
      if (passMethod) {
        this.recaptchaKey = passMethod.recaptchaKey
      }
      let dRM = this.defaultRegisterMethods()
      if (dRM) {
        let defaultMethods = dRM.split(' ')
        this.defaultMethods = this.accessMethods.filter(m => {
          return !!(m.oauth2_access_method && defaultMethods.includes('oidc:' + m.oauth2_access_method.id)) ||
            defaultMethods.includes(m.type)
        })
        if (this.defaultMethods && this.defaultMethods.length === 0) {
          this.defaultMethods = null
        }
      }
      this.methodsHidden = this.defaultMethods ? this.accessMethods.length > this.defaultMethods.length : false
    } else {
      let userParam = this.urlParams.get('user')
      let userInfo = userParam ? Base64.parse(userParam) : null
      this.userInfo = userInfo ? JSON.parse(userInfo.toString(CryptoJS.enc.Utf8)) || null : null
      if (this.userInfo) {
        this.firstname = this.userInfo.firstname
        this.lastname = this.userInfo.lastname
        this.email = this.userInfo.email
      } else {
        this.firstname = this.urlParams.get('firstname') || ''
        this.lastname = this.urlParams.get('lastname') || ''
        this.email = this.urlParams.get('username') || decodeURIComponent(this.urlParams.get('email') || '')
      }
    }
    this.advancedUser = this.urlParams.get('advanced_user') === 'true' || false
    this.promoCode = this.urlParams.get('promo_code') || ''
  },
  destroyed () {
    this.$root.$off('closeDialog')
  },
  mounted () {
    if (this.recaptchaKey) {
      if (document.querySelector('body').setActive !== undefined) {
        document.querySelector('body').setActive()
      }
      window.grecaptcha.render(this.$refs['recaptcha'])
    }
  },
  methods: {
    defaultRegisterMethods () {
      return decodeURIComponent(this.urlParams.get('default_register_methods')) || null
    },
    getPassword () {
      let hashedPass = sha256(this.password)
      return hashedPass.toString()
    }
  },
  watch: {
    defaultMethods (val) {
      if (!val) {
        this.methodsHidden = false
      }
    },
    reset (val) {
      if (val) {
        this.firstname = ''
        this.lastname = ''
        this.email = ''
        this.password = ''
        this.repeatPassword = ''
        this.terms = false
        this.privacy = false
        this.commercial = false
        this.$refs.form.reset()
        this.resetValidation()
        this.$emit('update:reset', false)
        this.$emit('update:loading', false)
      }
    }
  },
  computed: {
    locale () {
      return this.$root.$i18n.locale
    }
  }
}
